export { default as en } from './en.i18n.json'
export { default as fr } from './fr.i18n.json'
export { default as zh } from './zh.i18n.json'
